import React, { memo, useEffect } from "react";
import { Marker, Popup } from "react-leaflet";
import { Box, Typography } from "@material-ui/core";
import { capitalize, remCalc } from "../../utils/helpers";
import L from "leaflet";
import { setHoverStop } from "../../store/actions/map";
import { connect } from "react-redux";
import { snapToRoadIcon } from "../icons/SnapToRoadIcon";

function propsEqual(p, n) {
  return (
    p.editId === n.editId &&
    p.transform === n.transform &&
    p.routeIndex === n.routeIndex &&
    p.iconHtml === n.iconHtml &&
    p.showSnapToRoad === n.showSnapToRoad &&
    p.stop.id === n.stop.id &&
    p.isEditing === n.isEditing &&
    p.stop.address.lat === n.stop.address.lat &&
    p.stop.address.lng === n.stop.address.lng &&
    p.stop.type === n.stop.type
  );
}

export let path;

export let pathEdit;

function MarkerWrapper({
  stop,
  isEditing,
  routeIndex,
  index,
  isHover,
  snapToRoad,
  map,
  routeId,
  iconHtml,
  getZindex,
  handleClick,
  isStartEnd,
  pane,
  setHoverStop,
  showSnapToRoad
}) {
  useEffect(() => {
    const mapRef = map && map.current;
    if (showSnapToRoad) {
      if (path) {
        mapRef.leafletElement.removeLayer(path);
      }
      if (pathEdit && isEditing) {
        mapRef.leafletElement.removeLayer(pathEdit);
      }

      var latlngs = [];

      var latlng1 = [
          stop.address.lat_str || stop.address.lat || "",
          stop.address.lng_str || stop.address.lng || ""
        ],
        latlng2 = [stop.address.lat, stop.address.lng];

      // some math
      var offsetX = latlng2[1] - latlng1[1],
        offsetY = latlng2[0] - latlng1[0];

      var r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2)),
        theta = Math.atan2(offsetY, offsetX);

      var thetaOffset = 3.14 / 10;

      var r2 = r / 2 / Math.cos(thetaOffset),
        theta2 = theta + thetaOffset;

      var midpointX = r2 * Math.cos(theta2) + latlng1[1],
        midpointY = r2 * Math.sin(theta2) + latlng1[0];

      var midpointLatLng = [midpointY, midpointX];

      latlngs.push(latlng1, midpointLatLng, latlng2);

      var pathOptions = {
        color: "rgba(0,0,0,0.9)",
        dashArray: "10"
      };
      if (isEditing) {
        pathEdit = L.curve(
          ["M", latlng1, "Q", midpointLatLng, latlng2],
          pathOptions
        ).addTo(mapRef.leafletElement);
      } else {
        path = L.curve(
          ["M", latlng1, "Q", midpointLatLng, latlng2],
          pathOptions
        ).addTo(mapRef.leafletElement);
      }
    } else {
      if (map && mapRef && mapRef.leafletElement) {
        if (path) mapRef.leafletElement.removeLayer(path);
        if (isEditing && pathEdit) mapRef.leafletElement.removeLayer(pathEdit);
      }
    }

    return () => {
      if (map && mapRef && mapRef.leafletElement && path && !showSnapToRoad) {
        mapRef.leafletElement.removeLayer(path);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stop, snapToRoad, iconHtml, showSnapToRoad]);

  const zIndex = getZindex(stop);

  return (
    <>
      {!snapToRoad && !(isHover && isEditing) && (
        <Marker
          onClick={() => handleClick(stop.id, stop.type, stop.status)}
          position={[stop.address.lat, stop.address.lng]}
          zIndexOffset={zIndex}
          pane={pane || "cluster"}
          key={stop.id}
          icon={window.L.divIcon({
            iconSize: [40, 47],
            iconAnchor: [20, isEditing ? 32 : routeIndex > -1 ? 40 : 25],
            html: iconHtml
          })}
          onMouseOver={e => {
            e.originalEvent.stopPropagation();
            if (
              e.latlng.lat === stop.address.lat &&
              e.latlng.lng === stop.address.lng &&
              !isEditing
            ) {
              setHoverStop({ stop, routeId, snapToRoad: true });
            }
          }}
          onMouseOut={e => {
            setHoverStop(null);
          }}
          children={
            isStartEnd(stop.type) ? (
              <Popup>
                <Box>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    Route {index}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="secondary"
                    style={{ fontStyle: "italic", fontSize: remCalc(12) }}
                  >
                    {capitalize(stop.type)} location
                  </Typography>
                </Box>
              </Popup>
            ) : null
          }
        />
      )}
      {showSnapToRoad && (
        <Marker
          position={[
            stop.address.lat_str || stop.address.lat || "",
            stop.address.lng_str || stop.address.lng || ""
          ]}
          zIndexOffset={zIndex}
          pane={"snapToRoad"}
          key={stop.id}
          icon={window.L.divIcon({
            iconSize: [30, 51],
            iconAnchor: [15, 32],
            html: snapToRoadIcon
          })}
        />
      )}
    </>
  );
}
const mapStateToProps = (state, props) => {
  const showSnapToRoad =
    state.map.snapToRoadEnabled &&
    props.stop &&
    props.stop.address?.lat_str &&
    (props.isHover || props.isEditing) &&
    props.map &&
    props.map.current &&
    props.map.current.leafletElement &&
    state.map.mapZoom >= 15;

  return {
    showSnapToRoad
  };
};

export default connect(mapStateToProps, { setHoverStop })(
  memo(MarkerWrapper, propsEqual)
);
